<template>
  <v-card>
    <v-card-title>
      {{ $t('title.settings_printer') }}
    </v-card-title>
    <v-card-text>
      <v-btn
        v-if="!printer"
        large
        block
        @click="searchPrinter"
        v-html="$t('field.settings.printer_connect_new')"
      />
      <template v-else>
        <h4 class="mb-2">
          {{ $t('field.settings.printer_connected') }}
          <b>{{ printer.name }}</b>
        </h4>

        <div class="d-flex">
          <v-btn
            large
            @click="testPrint"
            v-html="$t('field.settings.printer_test')"
          />
          <v-btn
            class="ml-auto"
            large
            @click="printer = null"
            v-html="$t('field.settings.printer_forgot')"
          />
        </div>
      </template>
    </v-card-text>

    <v-dialog v-model="printerDialog">
      <v-list>
        <v-subheader>
          {{ $t(printers.length === 0 ? 'title.settings_no_printer' : 'title.settings_select_printer') }}
        </v-subheader>
        <v-list-item
          v-for="(item, i) in printers"
          :key="i"
          two-line
          @click="selectPrinter(item)"
        >
          <v-list-item-content>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
            <v-list-item-subtitle>{{ item.mac }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-dialog>
  </v-card>
</template>

<script>
import { $alert, $bluetoothPrint } from '@/modules/Utils'
import { MetierLocalStorage } from 'modulelocalstorage'

export default {
  name: 'PrinterSettings',

  data () {
    return {
      printers: [],
      printerDialog: false
    }
  },

  computed: {
    printer: {
      get () { return this.$store.state.printer },
      set (val) {
        MetierLocalStorage.setPrinter(val)
        this.$store.commit('printer', val)
        if (IS_PAX) {
          CissAndroid.setMacPrinter(val ? val.mac : null)
        }
      }
    }
  },

  methods: {
    searchPrinter () {
      this.printers = []

      BTPrinter.list(
        (data) => {
          let printer = {}
          for (let i = 0; i < data.length; i++) {
            if (i % 3 === 0) printer.name = data[i]
            if (i % 3 === 1) printer.mac = data[i]
            if (i % 3 === 2) {
              this.printers.push(printer)
              printer = {}
            }
          }
          this.printerDialog = true
        },
        (err) => {
          $alert(err)
        }
      )
    },
    selectPrinter (item) {
      this.printer = item
      this.printerDialog = false
    },
    testPrint () {
      if (IS_PAX) {
        Pax.printBT(
          {
            mac: this.printer.mac,
            lines: [
              { text: 'Test d\'impression', align: 'L' },
              { text: 'Test deuxième ligne', align: 'L' }
            ]
          },
          () => {},
          (error) => {
            $alert(error)
          }
        )
      } else {
        $bluetoothPrint(this.printer.name, 'Test d\'impression\nAvec deuxième ligne')
      }
    }
  }
}
</script>
